module.exports = __webpack_public_path__ + "img/mail-checkout-1.83fd301b.svg";